import '../ui-anchor/ui-anchor.ru';
import '../ui-annotation/ui-annotation.ru';
import '../ui-assets/ui-assets.ru';
import '../ui-autocomplete/ui-autocomplete.ru';
import '../ui-breadcrumbs/ui-breadcrumbs.ru';
import '../ui-button/ui-button.ru';
import '../ui-calendar/ui-calendar.ru';
import '../ui-chip/ui-chip.ru';
import '../ui-comparison-cards/ui-comparison-cards.ru';
import '../ui-countdown/ui-countdown.ru';
import '../ui-curtain/ui-curtain.ru';
import '../ui-datepicker/ui-datepicker.ru';
import '../ui-daterange/ui-daterange.ru';
import '../ui-dialogbubble/ui-dialogbubble.ru';
import '../ui-dropdown/ui-dropdown.ru';
import '../ui-feedback/ui-feedback.ru';
import '../ui-field/ui-field.ru';
import '../ui-footer/ui-footer.ru';
import '../ui-form/ui-form.ru';
import '../ui-message/ui-message.ru';
import '../ui-modal/ui-modal.ru';
import '../ui-monthpicker/ui-monthpicker.ru';
import '../ui-nav/ui-nav.ru';
import '../ui-navitem/ui-navitem.ru';
import '../ui-navlist/ui-navlist.ru';
import '../ui-navtoggle/ui-navtoggle.ru';
import '../ui-offer/ui-offer.ru';
import '../ui-salesribbon/ui-salesribbon.ru';
import '../ui-pagination/ui-pagination.ru';
import '../ui-phonefield/ui-phonefield.ru';
import '../ui-searchinput/ui-searchinput.ru';
import '../ui-signing/ui-signing.ru';
import '../ui-skip-to-content/ui-skip-to-content.ru';
import '../ui-slider/ui-slider.ru';
import '../ui-slides/ui-slides.ru';
import '../ui-stepper/ui-stepper.ru';
import '../ui-table-cloneable/ui-table-cloneable.ru';
import '../ui-table-expandable/ui-table-expandable.ru';
import '../ui-table-sortable/ui-table-sortable.ru';
import '../ui-tabs/ui-tabs.ru';
import '../ui-textcounter/ui-textcounter.ru';
import '../ui-timerange/ui-timerange.ru';
import '../ui-tooltip/ui-tooltip.ru';
import '../ui-upload-item/ui-upload-item.ru';
import '../ui-upload/ui-upload.ru';
import '../ui-video/ui-video.ru';
import '../ui-wizard/ui-wizard.ru';
import '../ui-asset/ui-asset.ru';
import '../ui-slideview/ui-slideview.ru';
import '../ui-rating/ui-rating.ru';
import { Labels } from '../../shared-components/global/labels';
import { Language } from '../../shared-components/global/enums';

Labels.LANGUAGE = Language.Russian;

window.UI = { ...window.UI, Labels };
